<script lang="ts">
import Vue, { CreateElement, PropType, RenderContext, VNode } from 'vue';

import { IDeal } from '@/bundles/Deal/types';
import { getDealTransactionTypeLabel } from '@/bundles/Deal/helpers/transaction/getDealTransactionLabel';
import { formatCurrency, formatDate, formatNumber } from '@/utils/filters';
import { LocalizationEnum } from '@/bundles/Localization/enum/LocalizationEnum';
import i18n from '@/bundles/Localization';

import BuildingSizeLabel from '@/bundles/MeasurementUnits/components/BuildingSizeLabel.vue';
import LandSizeLabel from '@/bundles/MeasurementUnits/components/LandSizeLabel.vue';
import Label from '@/bundles/Common/components/Label.vue';

export default Vue.extend({
  name: 'DealCardRelatedContent',

  functional: true,

  props: {
    deal: {
      type: Object as PropType<IDeal>,
      required: true
    }
  },

  render (h: CreateElement, { props }: RenderContext): VNode {
    const children = [
      h('div', [
        h('strong', `${i18n.t(LocalizationEnum.transaction_type)}: `),
        h('span', { style: { textTransform: 'capitalize' } }, getDealTransactionTypeLabel(props.deal))
      ]),

      h('div', [
        h('strong', 'Property Type: '),
        h(Label, { style: { textTransform: 'capitalize' }, props: { value: props.deal.property?.type } }),
      ]),

      props.deal.suite
        ? h('div', [
          h('strong', 'Suite #: '),
          h('span', props.deal.suite)
        ])
        : null,

      props.deal.transaction && 'total_square_feet' in props.deal.transaction
        ? h('div', [
          h('strong', 'Space Size: '),
          h(BuildingSizeLabel, { props: { value: formatNumber(props.deal.transaction.total_square_feet) } })
        ])
        : null,

      props.deal.transaction && 'total_acres' in props.deal.transaction
        ? h('div', [
          h('strong', 'Land Size: '),
          h(LandSizeLabel, { props: { value: props.deal.transaction.total_acres } })
        ])
        : null,

      props.deal.transaction && 'consideration' in props.deal.transaction
        ? h('div', [
          h('strong', 'Total Consideration: '),
          h('span', formatCurrency(props.deal.transaction.consideration))
        ])
        : null,

      props.deal.transaction && 'total_commission' in props.deal.transaction
        ? h('div', [
          h('strong', 'Total Commission: '),
          h('span', formatCurrency(props.deal.transaction.total_commission))
        ])
        : null,

      h('div', [
        h('strong', 'Transaction Date: '),
        h(Label, {
          props: {
            value: props.deal.transaction?.transaction_date || props.deal.transaction_date
              ? formatDate(props.deal.transaction?.transaction_date || props.deal.transaction_date)
              : null
          }
        })
      ])
    ];

    return h('div', children.filter(Boolean));
  }
})
</script>
